<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
        <div class="wrap">
            <div class="title-box">
                <div class="tit">{{learn.title}}</div>
                <div class="desc">{{learn.desc}}</div>
            </div>
            <div class="category" style="display: none;">
                <div class="center">
                    <div class="left item" :class="[tab == 1 ? 'active' : '']" @click="setTab(1)"><div class="middle">演讲环节</div></div>
                    <div class="left item" :class="[tab == 2 ? 'active' : '']" @click="setTab(2)"><div class="middle">展位</div></div>
                    <div class="left item" :class="[tab == 3 ? 'active' : '']" @click="setTab(3)"><div class="middle">赞助商</div></div>
                </div>
            </div>
            <div class="list-box">
                <div class="box plan-box" :class="[tab == 1 ? 'active' : '']">
                    <div class="item-l" :class="['status-'+sessionStatus(item,index)]" v-if="item" v-for="(item,index) in session" @click="toSession(item,index)">
                        <div class="image"></div>
                        <div class="status-box">
                            <div class="left time"><span>{{tool.date.formatDate('H:i',item.live_start)}} - {{tool.date.formatDate('H:i',item.live_end)}}</span></div>
                            <div class="right status"></div>
                        </div>
                        <div class="info info-1" v-if="item.id == 7">
                            <div class="middle">
                                <div class="title">领导致辞</div>
                                <div class="topic" style="display: none">
                                    <div class="speaker">
                                        <div class="clear li"><span class="aa">Michael Dell</span><i class="aa">Chairman and CEO Dell Technologies</i></div>
                                        <div class="clear li"><span class="aa">Aongus Hegarty</span><i class="aa">President,International Markets Technologies</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 8">
                            <div class="middle">
                                <div class="title">英特尔助力数字化转型</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>梁雅莉</span><i class="auto">英特尔公司市场营销集团副总裁 中国区行业解决方案部总经理</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 6">
                            <div class="middle">
                                <div class="title"><sup>Hot</sup>热科技 抢先看</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>李三平</span><i>戴尔科技集团中国研发集团 首席科学家</i></div>
                                        <div class="clear li"><span>高健</span><i class="auto">戴尔科技集团软件研发总监 PowerStore中国研发团队负责人</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 4">
                            <div class="middle">
                                <div class="title">开场致词—攀登者 中国精神</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 1">
                            <div class="middle">
                                <div class="title">高端对话《攀登者》</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li hide"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        <div class="clear li"><span>唐维红</span><i>人民网党委委员 监事会主席</i></div>
                                        <div class="clear li"><span>夏伯渝</span><i>中国登山家 电影《攀登者》原型</i></div>
                                        <div class="clear li"><span>许博</span><i>人民网主持人</i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-2" v-if="item.id == 2">
                            <div class="middle">
                                <div class="title">以科技之名，致敬攀登者！</div>
                                <div class="topic">
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智国</i>新基建—中国经济新动能</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        </div>
                                    </div>
                                    <div class=" ll">
                                        <div class="tit"><i>科技 · 智造</i>加速从“制造”到“智造”</div>
                                        <div class="speaker">
                                            <div class="clear li hide"><span>潘广崇</span><i>金风科技集团首席转型官</i></div>
                                            <div class="clear li"><span>吴冬梅</span><i>戴尔科技集团全球资深副总裁 中国核心客户和全球客户事业部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智学</i>教育“智能化”是产业趋势</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>应质峰</span><i>复旦大学教务处副处长 创新创业学院副院长</i></div>
                                            <div class="clear li top"><span>陈春曦</span><i>戴尔科技集团中国研发集团 上海公司总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技 · 智医</i>推进“健康中国”大战略</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>李柏</span><i>全景智联科技有限公司联合创始人、执行总裁</i></div>
                                            <div class="clear li"><span>孔大勇</span><i>戴尔科技集团全球副总裁  大中华区存储平台及解决方案事业部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll large ">
                                        <div class="tit"><i>智能研究基地战略合作揭牌仪式</i></div>
                                        <div class="speaker">
                                            <div class="clear li"><span>程健</span><i>中国科学院自动化研究所人工智能与先进计算联合实验室主任<br/>南京人工智能芯片创新研究院常务副院长</i></div>
                                            <div class="clear li"><span>唐胜宏</span><i>人民网研究院常务副院长</i></div>
                                            <div class="clear li"><span>黄陈宏</span><i>戴尔科技集团大中华区董事长兼总裁</i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-2" v-if="item.id == 3">
                            <div class="middle">
                                <div class="title">‘在中国 为中国’ 与攀登者共建数字企业</div>
                                <div class="topic">
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 简</i>新一代信息技术创造“快通道”</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>刘伟</span><i>戴尔科技集团全球副总裁 中国研发集团总经理</i></div>
                                            <div class="clear li"><span>杨捷</span><i>戴尔科技集团高级总监 大中华区售前系统工程部总经理</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 新</i>行业转型智能化创新应用</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>孔大勇</span><i>戴尔科技集团全球副总裁 大中华区存储平台及解决方案事业部总经理 </i></div>
                                            <div class="clear li"><span>李三平</span><i>戴尔科技集团中国研发集团 首席科学家</i></div>
                                        </div>
                                    </div>
                                    <div class="ll">
                                        <div class="tit"><i>科技至 · 远</i>构筑可持续发展的技术与实力</div>
                                        <div class="speaker">
                                            <div class="clear li"><span>周兵</span><i>戴尔科技集团全球副总裁 大中华区政府事务部</i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info info-1" v-if="item.id == 5">
                            <div class="middle">
                                <div class="title">人民网网友互动问答</div>
                                <div class="topic">
                                    <div class="speaker">
                                        <div class="clear li"><span class="auto">戴尔科技领导代表黄陈宏、周兵、刘伟</span></div>
                                        <div class="clear li"><span class="auto">人民网主持人</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-loading" v-if="data_loading"><loading></loading></div>
                </div>
                <div class="box product-box" :class="[tab == 2 ? 'active' : '']">
<!--                    <div class="exhibition" @click="util.toLink('https://dell.com','','_blank')">-->
<!--                        <img :src="require('@/assets/image/m_exhibition.jpg')" alt="">-->
<!--                    </div>-->
                    <div class="left item" @click="toProductDetail(item)" v-for="item in product">
                        <div class="logo">
                            <div class="img" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                        </div>
                        <div class="element-more tit">{{item.title}}</div>
                        <div class="element-more desc">{{item.min_desc}}</div>
                    </div>
                </div>
                <div class="box dell-sponsor-box" :class="[tab == 3 ? 'active' : '']">
                    <div class="sponsor" v-if="showSponsor(1)">
                        <div class="title">我们的赞助商</div>
                        <div class="line"></div>
                        <div class="list">
                            <div class="item" v-for="item in sponsor" v-if="item && item.type == 1" @click="toSponsorDetail(item)">
                                <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="sponsor" v-if="showSponsor(2)">
                        <div class="title">特别感谢</div>
                        <div class="line"></div>
                        <div class="list list">
                            <div class="item" v-for="item in sponsor" v-if="item && item.type == 2" @click="toSponsorDetail(item)">
                                <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                            </div>
                        </div>
                    </div>
                    <div class="sponsor" v-if="showSponsor(3)">
                        <div class="title">其他合作伙伴</div>
                        <div class="line"></div>
                        <div class="list list-l">
                            <div class="left item" v-for="item in sponsor" v-if="item && item.type == 3" @click="toSponsorDetail(item,true)">
                                <div class="logo" :style="{backgroundImage:'url('+util.autoImage(item.logo)+')'}"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import Crumbs from "../../../components/m/Crumbs";
    import Loading from "../../../components/m/Loading";
    export default {
        name: 'index',
        data() {
            return {
                query:"",
                tab:2,
                learn:{},
                session:[],
                product:[],
                sponsor:[],
                page:1,
                swiper_1:'',
                swiper_2:"",
                data_loading:true,
                service_time:0,

                time_list:[],
                now_time:0
            }
        },
        components:{
            Loading,
            Crumbs
        },
        computed:{
            week_array(){
                return  ["星期日","星期一","星期二","星期三","星期四","星期五","星期六",]
            },
            crumbs() {
				return {title:"联系戴尔",min_title:"CONTACT DELL"}
            },
            form(){
                return {id:1,title:"主会场-大会和主题演讲",list:3,link:"http://dtf.evp.mudu.tv/watch/7r4br30o"}
            },
        },
        watch:{
            '$route' (to, from) {
                if(to.query.type != from.query.type){
                    this.query = this.$route.query;
                    this.getLearn();
                }
            },
            now_time(newVal,oldVal){
                if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
                    this.getLearnSession();
                }
            }
        },
        methods: {
            toProductDetail(item){
                var url = "/partner/detail?product_id="+item.id;
                if(this.$store.state.user_info.id){
                    this.util.toLink(url);
                }else{
                    this.util.toLink(url);
                }
            },
            toSponsorDetail(item,link=false){
                if(item.show_detail == 2){
                    this.util.toLink(item.link,'','_blank');
                }else{
                    var url = "/sponsor/detail?sponsor_id="+item.id;
                    if(this.$store.state.user_info.id){
                        this.util.toLink(url);
                    }else{
                        this.util.toLink(url);
                    }
                }
            },
            setTab(tab){
                this.tab = tab;
            },
            showSponsor(type){
                var flag = false;
                for(var i =0;i<this.sponsor.length;i++){
                    if(this.sponsor[i] && this.sponsor[i].type == type){
                        flag = true;
                    }
                }
                return flag;
            },
            sessionStatus(item,index){
                var now_time = this.service_time;
                if(now_time < parseInt(item.live_start)){
                    if(index == 0){
                        if(now_time < parseInt(item.live_start) - 30*60){
                            return 1;
                        }else{
                            return 4;
                        }
                    }else{
                        return 1;
                    }
                }else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
                    return 2;
                }else{
                    return 3;
                }
            },
            toSession(item,index){
                var status = this.sessionStatus(item,index);
                if(status == 1){
                    return false;
                }else{
                    var url = this.global.MUDU_HOST +item.live_code;
                    if(this.$store.state.user_info.id){
                        var router = this.$router.resolve({
                            path:"/auth",
                            query:{
                                live_code:item.live_code,
                                redirect:url
                            }
                        });
                        window.open(router.href, '_blank');
                    }else{
                        var from = "/auth?live_code="+item.live_code+"&redirect="+url
                        this.util.showAuth({
                            show:true,
                            from:from
                        });
                    }
                }
            },
            getLearn(){
                this.http.request({
                    api:"learn/getLearn",
                    data:{
                        type:this.query.type,
                    },
                    success:(res)=>{
                        this.learn = res.learn;
                        this.service_time = res.service_time
                        this.getLearnSession();
                        this.getLearnProduct();
                        this.getLearnSponsor();
                    }
                })
            },
            getLearnSession(){
                this.http.request({
                    api:"learn/getLearnTopic",
                    data:{
                        learn_id:this.learn.id
                    },
                    success:(res)=>{
                        this.session = res.list;
                        this.service_time = res.service_time

                        var time_list = [];
                        for(var i =0;i<this.session.length;i++){
                            if(this.session[i]){
                                time_list.push(this.session[i].live_start)
                                time_list.push(this.session[i].live_end)
                            }
                        }
                        this.time_list = time_list;

                        this.data_loading = false;
                        this.$nextTick(()=>{
                            this.util.showBottom(true);
                        })
                    }
                })
            },
            getLearnProduct(){
                this.http.request({
                    api:"learn/getLearnProduct",
                    data:{
                        learn_id:this.learn.id,
                        page:1,
                        limit:100,
                    },
                    success:(res)=>{
                        this.product = res.list;
                    }
                })
            },
            getLearnSponsor(){
                this.http.request({
                    api:"learn/getLearnSponsor",
                    data:{
                        learn_id:this.learn.id
                    },
                    success:(res)=>{
                        this.sponsor = res.list;
                    }
                })
            },
            refresh(){
                this.timer = setInterval(()=>{
                    var myDate = new Date();
                    this.now_time = parseInt(myDate.getTime()/1000);
                },1000)
            },
        },
        mounted() {
            this.query = this.$route.query;
            this.getLearn();
            this.refresh();
        },
        destroyed() {
            clearInterval(this.timer);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .wrap{background:#f6f6f6 url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;padding-top: .25rem;
        .title-box{padding:.25rem;background: #fff;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);width: 6.5rem;margin: 0 auto;display: none;
            .tit{font-size:.26rem;line-height:.32rem;border-left: .04rem solid #0176ce;padding-left:.1rem;font-weight: bold;}
            .desc{font-size: .22rem;margin-top: .1rem;line-height: .32rem;color:#565656;padding-left: .14rem;white-space: pre-line}
        }
        .category{height:.9rem;margin: .25rem auto 0;background: #fff;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);text-align: center;
            .center{display: inline-block;
                .item{width: 2.33rem;height:.9rem; ;text-align: center;color:#565656;font-size: .24rem;transition: all .3s ease;cursor: pointer;
                    .middle{height:.9rem;width: 2.3rem;line-height: .34rem;}
                }
                .item.active{background: #0176ce;color: #fff;transition: all .3s ease;position: relative}
                .item.active::after{content: "";display: block;width: 100%;height: .1rem;position: absolute;left:0;bottom:0;background: #63b4e1;}
            }
        }
        .list-box{padding: .25rem; overflow: hidden;
            .box{display: none;}
            .box.active{display: block}
            .box.product-box{width:7rem;margin: 0 auto;display: flex;flex-wrap: wrap;
                .item{width:3.4rem;padding-bottom: .25rem; background: #fff;margin-right: .2rem;margin-bottom: .2rem;border-radius:.05rem;cursor: pointer;transition: all .3s ease;
                    .logo{height:1.6rem;padding: .25rem;
                        .img{width: 100%;height:100%; background: url("~@/assets/image/51.png") no-repeat center center;background-size: cover;}
                    }
                    .tit{padding: 0 .25rem;font-size: .26rem;line-height: .4rem;}
                    .desc{padding: 0 .25rem;margin-top:.1rem;font-size: .22rem;color:#929292;line-height: .3rem; -webkit-line-clamp:5;white-space: pre-line}
                }
                .item:nth-child(2n){margin-right: 0;}
            }
            .box.plan-box{
                .item-l{margin-bottom: .25rem; box-shadow: .05rem .05rem .1rem .02rem rgba(0,0,0,.1);border-radius:.1rem;overflow: hidden;float: left;position: relative;cursor: pointer;width: 7rem;background: #fff;
                    .image{height:.04rem;}
                    .status-box{padding: 0 .2rem;overflow: hidden;height:.8rem;line-height: .8rem;
                        .time{height:.8rem;line-height: .8rem; font-size:.24rem;color:#376f84;font-weight: bold;
                            span{padding-left: .28rem;display: block;}
                        }
                        .status{float: right; width:1.07rem;height:.4rem;margin-top: .2rem; border-radius: .12rem;}
                    }
                    .info{padding: 0 .2rem .2rem;
                        .title{font-size: .28rem;color:#1b1b1b;font-weight: bold;line-height: .3rem;
                            sup{color:red;font-size:.18rem;margin-right: .02rem;}
                        }
                        .topic{
                            .speaker{
                                .li{margin-top: .15rem;
                                    span,i{display: block;}
                                    span{font-size: .21rem;color:#434343;line-height: .27rem;}
                                    i{font-size: .21rem;color:#929292;line-height: .27rem;}
                                }
                                .li:nth-last-child(1){margin-bottom: 0;}
                            }
                            .ll{padding: .2rem 0 .25rem;border-bottom: .02rem dashed #d9e8f2;
                                .tit{font-size: .26rem;color:#4c4c4c;padding-left: .2rem;background: url("~@/assets/image/m11.png") no-repeat left center;background-size: .1rem;
                                    i{margin-right: .15rem;}
                                }
                                .speaker{padding-left: .2rem;}
                            }
                            .ll:nth-last-child(1){border-bottom:none;padding-bottom: 0;}
                        }
                    }
                }
                .item-l.status-1{
                    .image{background:#c6e9f7;}
                    .status-box{
                        .time{
                            span{background: url("~@/assets/image/b32.png") no-repeat left center;background-size:.2rem;}
                        }
                        .status{background: url("~@/assets/image/b27.jpg") no-repeat center center;background-size: contain;}
                    }
                }
                .item-l.status-2{
                    .image{background:#c1d6ee;}
                    .status-box{
                        .time{
                            span{background: url("~@/assets/image/b33.png") no-repeat left center;background-size: .2rem;}
                        }
                        .status{background: url("~@/assets/image/b28.jpg") no-repeat center center;background-size: contain;}
                    }
                }
                .item-l.status-3{
                    .image{background:#eaeaea;}
                    .status-box{
                        .time{
                            span{background: url("~@/assets/image/b34.png") no-repeat left center;background-size: .2rem;}
                        }
                        .status{background: url("~@/assets/image/b29.jpg") no-repeat center center;background-size: contain;}
                    }
                }
                .item-l.status-4{
                    .image{background:#c1d6ee;}
                    .status-box{
                        .time{
                            span{background: url("~@/assets/image/b33.png") no-repeat left center;background-size: .2rem;}
                        }
                        .status{background: url("~@/assets/image/b28_1.png") no-repeat center center;background-size: contain;}
                    }
                }
                .empty{height:2rem;line-height:2rem;text-align: center;font-size: .24rem;color:#999;}
            }
            .box.dell-sponsor-box{
                .sponsor{margin: .5rem auto 0;
                    .title{font-size:.32rem;text-align: center}
                    .line{width:1.4rem;height:.04rem;margin:.05rem auto 0; background: #3176c8;}
                    .list{overflow: hidden;margin: .25rem auto 0;width: 7rem;
                        .item{padding: .5rem .3rem;background: #fff;text-align: center;
                            .logo{width:3.8rem;height:1rem;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                        }
                    }
                    .list.list-l{
                        .item{padding: .5rem .3rem;width: 2.8rem; background: #fff;margin-right: .2rem;margin-bottom: .2rem;
                            .logo{width:2rem;height:.7rem;margin: 0 auto; background: url("~@/assets/image/22.png") no-repeat center center;background-size: contain;}
                        }
                        .item:nth-child(2n){margin-right: 0;}
                    }
                }
            }
        }
    }
</style>

